import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-checkbox-group',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './checkbox-group.component.html',
  styleUrl: './checkbox-group.component.scss'
})
export class CheckboxGroupComponent {
  @Input() titles: string[] = [];
  @Output() selectionChange = new EventEmitter<{ [key: string]: boolean }>();

  selectedValues: { [key: string]: boolean } = {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes['titles'] && this.titles) {
      this.selectedValues = {};
      this.titles.forEach(title => {
        this.selectedValues[title] = false;
      });
    }
  }

  onCheckboxChange(title: string) {
    this.selectedValues[title] = !this.selectedValues[title];
    this.selectionChange.emit({ ...this.selectedValues }); // Emit a copy to avoid reference issues
  }
}
